export class Discount {
    public id: number;
    public title: string;
    public type: string;
    public code: string;
    public amount: number;
    public start: string;
    public end: string;
    public start_issue: string;
    public end_issue: string;
    public created: string;

    constructor(id: number, title: string,
                type: string, code: string, amount: number,
                start: string, end: string,
                start_issue: string, end_issue: string,
                created: string) {
        this.id = id;
        this.title = title;
        this.type = type;
        this.code = code;
        this.amount = amount;
        this.start = start;
        this.end = end;
        this.start_issue = start_issue;
        this.end_issue = end_issue;
        this.created = created;
    }

}

export class DiscountUpdate {
    public id: number;
    public title: string;
    public type: string;
    public code: string;
    public amount: number;
    public start: string;
    public end: string;
    public start_issue: string;
    public end_issue: string;

    constructor(id: number, title: string,
                type: string, code: string, amount: number,
                start: string, end: string,
                start_issue: string, end_issue: string
    ) {
        this.id = id;
        this.title = title;
        this.type = type;
        this.code = code;
        this.amount = amount;
        this.start = start;
        this.end = end;
        this.start_issue = start_issue;
        this.end_issue = end_issue;
    }
}

export class DiscountCreate {
    public title: string;
    public type: string;
    public code: string;
    public amount: number;
    public start: string;
    public end: string;
    public start_issue: string;
    public end_issue: string;

    constructor(title: string, type: string, code: string, amount: number,
                start: string, end: string,
                start_issue: string, end_issue: string) {
        this.title = title;
        this.type = type;
        this.code = code;
        this.amount = amount;
        this.start = start;
        this.end = end;
        this.start_issue = start_issue;
        this.end_issue = end_issue;
    }
}
